import { roundDownToNearestHundred } from '../lib/helpers';
import { sortDatesAscending } from '../lib/sorting';

import APIClient from './APIClient';

const {
  REACT_APP_ONBOARDING_API_HOST: ONBOARDING_API_HOST,
  REACT_APP_PERIODS_ENDPOINT: PERIODS_ENDPOINT,
  REACT_APP_BUILD_PERIODS_ENDPOINT: BUILD_PERIODS_ENDPOINT,
  REACT_APP_CALCULATE_LOAN_CURRENCY_COST_ENDPOINT: CALCULATE_LOAN_CURRENCY_COST_ENDPOINT,
} = process.env;

export const calculateLoanCurrencyCostUrl = (courseGuid, periodGuid) =>
  `${ONBOARDING_API_HOST}${CALCULATE_LOAN_CURRENCY_COST_ENDPOINT}`
    .replace('{courseId}', courseGuid)
    .replace('{periodId}', periodGuid);

export const urlFor = courseGuid =>
  `${ONBOARDING_API_HOST}${PERIODS_ENDPOINT}`.replace('{courseId}', courseGuid);

export const buildUrlFor = (
  courseGuid,
  programmeLengthStartDate,
  programmeLengthEndDate,
  tuitionCostAmount,
  livingExpensesAmount,
  depositAmount,
) =>
  `${ONBOARDING_API_HOST}${BUILD_PERIODS_ENDPOINT}`
    .replace('{courseId}', courseGuid)
    .replace('{programmeLengthStartDate}', programmeLengthStartDate)
    .replace('{programmeLengthEndDate}', programmeLengthEndDate)
    .replace(
      '{tuitionCostAmount}',
      typeof tuitionCostAmount === 'string' && tuitionCostAmount.length === 0
        ? 0
        : tuitionCostAmount,
    )
    .replace(
      '{livingExpensesAmount}',
      typeof livingExpensesAmount === 'string' && livingExpensesAmount.length === 0
        ? 0
        : livingExpensesAmount,
    )
    .replace(
      '{depositAmount}',
      typeof depositAmount === 'string' && depositAmount.length === 0 ? 0 : depositAmount,
    );

export default class PeriodsAPI {
  static calculateCostInLoanCurrency = (params, token) => {
    const { courseGuid, periodGuid } = params;
    return APIClient.post(calculateLoanCurrencyCostUrl(courseGuid, periodGuid), params, token).then(
      response => response.data,
    );
  };

  static getPeriodsFor = (courseGuid, token) =>
    APIClient.get(urlFor(courseGuid), token).then(response => {
      const periods = response.data.map(
        ({
          name,
          id,
          startDate,
          endDate,
          live,
          studentCosts,
          classId,
          className,
          classStatus,
          periodOrder,
          supported,
          displayStatus,
          minLoanSize,
        }) => ({
          periodGuid: id,
          periodName: name,
          startDate: Date.parse(startDate),
          endDate: Date.parse(endDate),
          live,
          currency: studentCosts.loanCurrency.costOfTuition.currency,
          deposit: Math.trunc(parseFloat(studentCosts.loanCurrency.deposit.amount)),
          costOfAttendance: roundDownToNearestHundred(
            Math.trunc(parseFloat(studentCosts.loanCurrency.livingExpenses.amount)) +
              Math.trunc(parseFloat(studentCosts.loanCurrency.costOfTuition.amount)),
          ),
          costOfLiving: Math.trunc(parseFloat(studentCosts.loanCurrency.livingExpenses.amount)),
          costOfTuition: Math.trunc(parseFloat(studentCosts.loanCurrency.costOfTuition.amount)),
          classId,
          className,
          classStatus,
          periodOrder: parseInt(periodOrder, 10),
          supported,
          displayStatus,
          minLoanSize,
        }),
      );

      return sortDatesAscending(periods, 'startDate');
    });

  static buildPeriodsFor = (params, token) => {
    const {
      courseGuid,
      programmeLengthStartDate,
      programmeLengthEndDate,
      tuitionCostAmount,
      livingExpensesAmount,
      depositAmount,
    } = params;

    return APIClient.get(
      buildUrlFor(
        courseGuid,
        programmeLengthStartDate,
        programmeLengthEndDate,
        tuitionCostAmount,
        livingExpensesAmount,
        depositAmount,
      ),
      token,
    ).then(response => {
      const periods = response.data.map(
        ({
          name,
          id,
          startDate,
          endDate,
          live,
          studentCosts,
          classId,
          className,
          classStatus,
          periodOrder,
          supported,
          displayStatus,
          minLoanSize,
          capOnLoanInfo,
        }) => ({
          periodGuid: id,
          periodName: name,
          startDate: Date.parse(startDate),
          endDate: Date.parse(endDate),
          live,
          currency: studentCosts.loanCurrency.costOfTuition.currency,
          deposit: Math.trunc(parseFloat(studentCosts.loanCurrency.deposit.amount)),
          // costOfAttendance: roundDownToNearestHundred(
          //   Math.trunc(parseFloat(studentCosts.loanCurrency.costOfAttendance.amount)),
          // ),
          costOfAttendance: roundDownToNearestHundred(
            Math.trunc(parseFloat(studentCosts.loanCurrency.livingExpenses.amount)) +
              Math.trunc(parseFloat(studentCosts.loanCurrency.costOfTuition.amount)),
          ),
          costOfLiving: Math.trunc(parseFloat(studentCosts.loanCurrency.livingExpenses.amount)),
          costOfTuition: Math.trunc(parseFloat(studentCosts.loanCurrency.costOfTuition.amount)),
          classId,
          className,
          classStatus,
          periodOrder: parseInt(periodOrder, 10),
          supported,
          displayStatus,
          minLoanSize,
          capOnLoanInfo,
        }),
      );

      return sortDatesAscending(periods, 'startDate');
    });
  };
}
